/**
 * The AI-review change-status layer (VALE-1174) — pattern Y6 of the VALE-1050
 * spike, promoted out of `components/prototypes/ai-review-status/`.
 *
 * Four parts, deliberately separate: the derivation from the wire contract
 * (`change-status`), the marks that render it (`change-marks`), the one
 * hover/click interaction (`change-popover`), and the treatment that applies
 * all three to an attribute grid (`use-ai-review-field-marking`, VALE-1249).
 *
 * **A surface adopts the treatment through `useAiReviewFieldMarking`**, not by
 * reaching for the marks directly. The parts below it stay exported because the
 * treatment is built from them, and because a surface's *own* chrome uses some
 * of them (the section legend, an item-level badge and popover) — but the rules
 * about a FIELD live in one place now, which is what VALE-1249 was for.
 */
export {
  countFieldChanges,
  describeChangeValue,
  fieldChangeFor,
  fieldChangeKind,
  itemChangeKind,
  rendersValueAsText,
  rowHoldsAValue,
  type FieldChangeKind,
  type ItemChangeKind,
  type ReviewItemStatus,
  type ReviewStatusMap
} from './change-status';

export {
  changeInkClassName,
  changeInkDescendantClassName,
  REJECTED_VALUE_INK,
  ChangeTag,
  ChangedValue,
  ItemChangeBadge,
  PreviousValue,
  NEW_VALUE_INK,
  UPDATED_VALUE_INK
} from './change-marks';

export {
  ChangePopover,
  useChangeHover,
  type ChangePopoverAction,
  type ChangePopoverProps
} from './change-popover';

export {
  keysTouchedByPatch,
  useReviewFieldEdits,
  type ReviewFieldEditsApi
} from './use-review-field-edits';

export {
  useReviewRejections,
  rejectedKeysFor,
  rejectedInventoryKeysFor,
  rejectedMatterKeysFor,
  NO_REJECTIONS,
  type ReviewRejections,
  type ReviewRejectionsApi
} from './use-review-rejections';

export {
  useAiReviewFieldMarking,
  contractKeysFor,
  patchKeyPaths,
  isExtractedFlag,
  isUnsetFlag,
  INKABLE_EDITOR_KINDS,
  type AiReviewFieldMarking,
  type AiReviewFieldMarkingOptions,
  type RowChange
} from './use-ai-review-field-marking';
